// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__FEAyS","thankyou1":"Thankyou_thankyou1__nDYLy","thankyou123":"Thankyou_thankyou123__2gKq-"};